<template>
  <v-dialog
    v-bind:value="value"
    v-on:click:outside="dispatchClose"
  >
    <v-card>
      <v-btn
        class="popup__exit"
        icon
        v-on:click="dispatchClose"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title>
        Выберите услуги
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-treeview
          v-bind:items="items"
          v-on:input="onChangeActive"
          selectable
          selection-type="leaf"
          transition />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ChooseServicesModalDialog',
  props: {
    items: { type: Array, required: true },
    value: { type: Boolean, required: true },
  },
  data() {
    return {
      selectedServices: [],
    };
  },
  methods: {
    /**
     * @description Вызвать событие закрытия диалога, при закрытии отправляем собранные данные
     */
    dispatchClose() {
      this.$emit('input', false);
      this.$emit('close');
      this.$emit('change', this.selectedServices);
    },
    /**
     * @description Изменение при активации закона
     *
     * @param selectedServices
     */
    onChangeActive(selectedServices) {
      this.selectedServices = selectedServices;
    },
  },
};
</script>

<style scoped>

</style>
